// extracted by mini-css-extract-plugin
module.exports = {"M":"contact_M__nU57u","ContactFormWrapper":"contact_ContactFormWrapper__OXyY3","ContactForm":"contact_ContactForm__1NUgv"};